export interface TutorialStep {
  id: string;
  title: string;
  goal: string;
}

export const TUTORIAL_STEPS: TutorialStep[] = [
  { id: 'tiles', title: '타일 익히기', goal: '만·통·삭과 자패(바람·삼원)를 구분한다' },
  { id: 'meld', title: '면자 만들기', goal: '슌쯔(연속 3장)와 커쯔(같은 3장)를 이해한다' },
  { id: 'tenpai', title: '텐파이', goal: '한 장만 더 모으면 화료가 되는 상태를 안다' },
  { id: 'agari', title: '화료', goal: '4면자 + 1작두(짝)로 손패를 완성한다' },
  { id: 'riichi', title: '리치', goal: '닫힌 텐파이에서 리치를 선언한다' },
  { id: 'score', title: '역과 점수', goal: '역이 붙어야 화료하며 점수가 매겨진다' },
];

const STEP_IDS = new Set(TUTORIAL_STEPS.map((s) => s.id));

export interface TutorialProgress {
  completedStepIds: string[];
}

export function createProgress(): TutorialProgress {
  return { completedStepIds: [] };
}

/** 유효 단계이고 아직 완료 안 했으면 추가(불변). */
export function completeStep(p: TutorialProgress, id: string): TutorialProgress {
  if (!STEP_IDS.has(id) || p.completedStepIds.includes(id)) return p;
  return { completedStepIds: [...p.completedStepIds, id] };
}

export function isStepComplete(p: TutorialProgress, id: string): boolean {
  return p.completedStepIds.includes(id);
}

export function isTutorialComplete(p: TutorialProgress): boolean {
  return TUTORIAL_STEPS.every((s) => p.completedStepIds.includes(s.id));
}

export function progressPercent(p: TutorialProgress): number {
  const done = p.completedStepIds.filter((id) => STEP_IDS.has(id)).length;
  return Math.round((done / TUTORIAL_STEPS.length) * 100);
}
